module.exports = __webpack_public_path__ + "static/img/14010112.aa1b430a.png";